export default "__VITE_ASSET__576ce570__"